
<template>

  <div  style="background: #fff;margin:10px;padding: 30px 0px;box-sizing: border-box;height: 100%;overflow: auto" v-loading="loading">
    <el-form ref="form" :model="form" label-width="130px" >
      <el-form-item label="选择题库" style="width: 100%">
        <el-select v-model="questionBank" clearable placeholder="请选择题库" @change="handleSelectedQuestionsBank" style="width: 95%">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备选题目" style="width: 100%;">
        <div style="display: inline-block;width: 100%;padding:0 60px 0 0;box-sizing: border-box">
        <el-table :data="tableData" border max-height="400"  :key="tableKey">
          <el-table-column label="#" type="index" width="50"></el-table-column>
          <el-table-column label="题目" min-width="300">
            <template v-slot="{row}">
              <span>{{ row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="选项内容" min-width="240">
            <template v-slot="{row}">
              <span>{{ row.option_text }}</span>
            </template>
          </el-table-column>
          <el-table-column label="题型" width="70">
            <template v-slot="{row}">
              <span>{{getQuestionTypeName(row.question_type) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="90">
            <template v-slot="{row}">
              <el-button type="text" v-if="!row.isSelected" icon="el-icon-time" size="mini" @click="handleSelected(row)" style="border-color: #CBA43F; color:#CBA43F;width: 80px">选择</el-button>
              <el-button type="text" v-if="row.isSelected" icon="el-icon-check"  :disabled="true" size="mini" style="border-color: #567722; color:#567722;width: 80px!important">已选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>
      </el-form-item>
      <el-form-item label="已选题目" style="width: 100%">

        <div style="display: inline-block;width: 100%;padding:0 60px 0 0;box-sizing: border-box">
          <el-radio-group v-model="tabPosition" @change="handleTabChange">
<!--            <el-radio-button v-for="item in typeList" :label="item.title">{{item.title}}</el-radio-button>-->
            <el-radio-button v-for="item in displayAll" :label="item.title" :value="item.id">{{item.title}}</el-radio-button>
          </el-radio-group>
        <el-table :data="tableData2" border style="width: 100%" max-height="400" row-key="id">
          <el-table-column label="#" type="index" width="50"></el-table-column>
          <el-table-column label="题目" min-width="300">
            <template v-slot="{row}">
              <span>{{ row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="选项内容" min-width="180">
            <template v-slot="{row}">
              <span>{{ row.option_text }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" min-width="120">
            <template v-slot="{row, $index}">
              <span type="text" v-if="$index >0" @click="handleMove($index, row, 'up')" style="color:#347CAF;margin-right: 10px;cursor: pointer">上移</span>
              <span type="text" v-if="$index !== tableData2.length-1" @click="handleMove($index, row, 'down')" style=" color:#347CAF;margin-right: 10px;cursor: pointer">下移</span>
              <span type="text"   @click="handleDelete($index, row)" style=" color:#E34D59;cursor: pointer">删除</span>
            </template>
          </el-table-column>
        </el-table>
        </div>
      </el-form-item>
      <el-form-item label="分值/题量设置"  style="width: 100%">
          <div style="display: inline-block;width: 100%">
            <div v-for="item in ruleList" class="socre-item">
              <div class="label"> <span style="vertical-align: middle;line-height: normal; /* 重置 span 自身行高 */">{{item.type_name}}：</span></div>

              <div class="value" style="display: inline-block;width: 72%;text-align: right">
              <div><span style="margin-right: 2px">共</span>
                <el-select v-model="item.question_count" size="mini" clearable placeholder="请选择" style="width: 70%">
                <el-option
                    v-for="(item,index) in scoreList"
                    :key="index"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
               <span style="margin-left: 2px">题</span>
              </div>
              <div>
                <span style="margin-right: 2px">每题</span>
                <el-select v-model="item.question_scores" size="mini" clearable placeholder="请选择" style="width: 70%">
                  <el-option
                      v-for="(item,index) in scoreList"
                      :key="index"
                      :label="item"
                      :value="item">
                  </el-option>
              </el-select>
                <span style="margin-left: 2px">分</span></div>
              </div>
            </div>
          </div>
      </el-form-item>

    </el-form>
    <div style="text-align: center;margin-top: 30px">
      <el-button type="primary" style="background-color: #E99D42;border-color:#E99D42" @click="handleSave(1)">发布</el-button>
      <el-button type="primary"   @click="handleSave(0)">保存</el-button>
      <el-button type="primary" style="background-color: #9B7D31;border-color:#9B7D31"  @click="handlePreview">预览</el-button>
      <el-button type="primary" style="background-color: #fff;border-color: #BBB;color:#000"  @click="handleCancel">取消</el-button>
    </div>
    <el-dialog
        title="校验确认"
        :visible="validateDialog"
        v-if="validateDialog"
        width="40%"
        @close="validateDialog=  false"
    >
      <span>选择题目与分类设置不一致，确定要继续提交吗？</span>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmSubmit()">确 定</el-button>
          <el-button @click="validateDialog = false">取 消</el-button>
        </span>
    </el-dialog>
  </div>

</template>
<script>
import {
  getExamQuestions,
  getExamRule, getQuetionList,
  getQuetionRepositories,
  getRepositoryDtl,
  saveExamQuestions, saveExamRule,
  updateExamRule
} from "@/api/training";

export default {
  name: "updateExam",
  data() {
    return {
      examId: null,
      loading:false,
      isPublish: 0,
      validateDialog:false, //规则校验弹窗
      tableKey: Date.now(), // 或其他唯一值
      allQuestions:[], // 接口获取的已选中所有题目原始结构-提交
      displayAll: [],// 接口获取的所有题目调整后所有的分类结构-展示
      tableData2: [], //当前表格展示的数据
      ruleList: [],
      tabPosition: '单选题',
      dialogVisible: false,
      typeList: [{title: '单选题', score: 1}],
      tableData: [],
      selectedList:[],
      isNewRule: true,
      questTypeList: [
          {
            type: '单选题',
            value: '单选题',
            score: '',
          },
          {
            type: '多选题',
            value: '多选题'
          },
          {
            type: '填空题',
            value: '填空题'
          },
          {
            type: '判断题',
            value: '判断题'
          },
          {
            type: '问答题',
            value: '问答题'
          },
          {
            type: '填空题',
          }
      ],
      scoreList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
      questionBank: [],
      options2: [
        {value: '10', label: '10'},
        {value: '20', label: '20'},
        {value: '30', label: '30'},
        {value: '40', label: '40'},
        {value: '50', label: '50'},
        {value: '60', label: '60'},
        {value: '70', label: '70'},
        {value: '80', label: '80'},
        {value: '90', label: '90'},
        {value: '100', label: '100'},
        {value: '110', label: '110'},
        {value: '120', label: '120'},
      ],
      options: [],
      filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1;
      },
      videoUrl: '',
      studyTime:'',
      form: {
        name: "",
        radio: 1,
        checked: "",
        desc: "",
        icon: "",
        dialogImageUrl: '',
        dialogVisible: false
      },
      typeMap:{
        2001: '单选题',
        2002: '多选题',
        2003: '是非题',
        2004: '填空题',
        2005: '问答题'
      }
    };
  },

  created() {
    this.examId = this.$route.query.id
    this.allQuestions = []
    this.displayAll = []
    this.tableData2 = []
    this.getQuetionRepositories() //获取题库下拉选项
    if(this.$route.query.isPreviewBack == 1){
      let tem1 = JSON.parse(sessionStorage.getItem('selectedList'));
      let tem2 = JSON.parse(sessionStorage.getItem('ruleList'));
      let tem3 = JSON.parse(sessionStorage.getItem('allQuestions'));
      this.displayAll = tem1
      this.tableData2 = tem1[0].dataList
      this.allQuestions = tem3
      this.ruleList =  tem2
    }else{
      this.getExamQuestionsList()
      this.getExamRule()
    }
  },
// 监听路由id变化调用方法
  watch: {
    examId: function (val) {
      this.questionBank = null
      this.tableData =[]
      this.ruleList = []
      if(this.$route.query.isPreviewBack == 1){
        let tem1 = JSON.parse(sessionStorage.getItem('selectedList'));
        let tem2 = JSON.parse(sessionStorage.getItem('ruleList'));
        let tem3 = JSON.parse(sessionStorage.getItem('allQuestions'));
        this.isNewRule = JSON.parse(sessionStorage.getItem('isNewRule'));
        this.displayAll = tem1
        this.tableData2 = tem1[0].dataList
        this.ruleList =  tem2
      }else{
        this.getExamQuestionsList()
        this.getExamRule()
      }

    }
  },
  methods: {
    getQuestionTypeName(typeId) {
      // 转为数字以兼容字符串输入（如 "2002"）
      const id = Number(typeId);
      return this.typeMap[id] || '未知题型';
    },
    getQuetionRepositories(){ //获取题库下拉选项
      getQuetionRepositories().then(res=>{
        let resData = res.data
        resData.forEach( item=>{
          item.label = item.title
          item.value = item.repository_id
        })
        this.options = resData
      })
    },
    handleSelectedQuestionsBank(val){ //获取题库对应的题目
      getQuetionList({repository_id: val,size:100}).then(res=>{
        this.tableData = res.data.data
        this.tableData.forEach( item=>{
          this.$set(item, 'isSelected', false);
        })

      })
    },
    getExamRule(){ //获取考试规则
      getExamRule({exam_id:this.$route.query.id}).then(res => {
        // 原始数据
        const data = res.data
        if(data.length >0){
          this.isNewRule = false
        }else{
          this.isNewRule = true
        }
        // 转换函数
        const transformData = (list) => {
          return list.map(item => ({
            ...item, // 保留原字段
            type_name: this.typeMap[item.question_type] || '未知题型' // 添加中文名称
          }));
        };
        this.ruleList = transformData(data)

      })
    },
    getExamQuestionsList(){ //获取已选中的题目
      this.loading = true
      getExamQuestions({exam_id:this.$route.query.id}).then(res => {
        this.loading = false
        this.allQuestions = res.data
        // 原始数据
        let resData = this.allQuestions
        // 转换函数
        const transformData = (data) => {
          return Object.keys(data).map(key => {
            const id = Number(key);
            const dataList = data[key];
            const title = this.typeMap[id] || '未知题型';
            return {
              id,
              title,
              dataList // 保持原数组
            };
          });
        };
       // 执行转换
        const result = transformData(resData);
        this.displayAll = result.filter(item => item.dataList.length > 0 )
        if(result.length >0){
          this.tabPosition = result.filter(item => item.dataList.length > 0 )[0].title
        }


        this.tableData2 = result.filter(item => item.title == this.tabPosition)[0].dataList
      }).finally(() => {
        this.loading = false
      })
    },
    // 上移或下移
    handleMove(index, row, direction) {
      const list = this.tableData2;
      const list2 = this.displayAll;
      //
      const targetType = row.question_type;
      const targetId = row.question_id;
      // 1. 找到对应的分组（question_type === id）
      const group = list2.find(item => item.id === targetType);
      if (!group || !Array.isArray(group.dataList)) {
        console.warn('未找到匹配的题型分组或 dataList 不存在');
        return;
      }
      const dataList = group.dataList;
      const currentIndex = dataList.findIndex(item => item.question_id === targetId);

      if (currentIndex === -1) {
        console.warn('未在 dataList 中找到匹配的题目');
        return;
      }
      let newIndex = -1;

      //
      if (direction === 'up' && currentIndex > 0) {
        [list[index], list[index - 1]] = [list[index - 1], list[index]];
        [dataList[currentIndex], dataList[currentIndex - 1]] = [dataList[currentIndex - 1], dataList[currentIndex]];
        newIndex = currentIndex - 1;
      } else if (direction === 'down' && currentIndex < dataList.length - 1) {
        [list[index], list[index + 1]] = [list[index + 1], list[index]];
        [dataList[currentIndex], dataList[currentIndex + 1]] = [dataList[currentIndex + 1], dataList[currentIndex]];
        newIndex = currentIndex + 1;
      }
      this.tableData2 = [...this.tableData2]
      this.displayAll = [...list2];
    },
    handleSelected(row){ //选中1个题目，点击选择按钮
      row.isSelected = true;  // 选中
      // this.tableData2.push(row);
      // 在展示的总数据中添加（预览用到）
      // 查找对应题型分组
      const targetGroup = this.displayAll.find(group => group.id === row.question_type);
      if (targetGroup) {
        // 防止重复添加（可选）：检查是否已存在相同 question_id
        const exists = targetGroup.dataList.some(item => item.question_id === row.question_id);
        if (!exists) {
          targetGroup.dataList.push(row);
        }
      } else {
        // 如果分组不存在，可选择动态创建（根据业务需要）
        this.displayAll.push({
          id: row.question_type,
          title: this.getQuestionTypeName(row.question_type), // 你需要提供这个方法
          dataList: [row]
        });
       this.handleSort()
      }
      // 在提交的数据中添加
      // 确保 this.allQuestions[2001] 存在且是数组
      if (!this.allQuestions[row.question_type]) {
        this.allQuestions[row.question_type] = [];
      }
      // 可选：防止重复添加（根据 question_id）
      const exists = this.allQuestions[row.question_type].some(
          item => item.question_id === row.question_id
      );
      if (!exists) {
        this.allQuestions[row.question_type].push(row);
        // if( this.allQuestions[row.question_type].length == 1){ //如果刚开始选某种类型的第一道题时，则将tabPosition设置为该题型
          this.tabPosition = this.typeMap[row.question_type]
          this.tableData2 = this.allQuestions[row.question_type]
        // }

      }
      let scoreTemp = 0
      // 添加分值和题量设置数据
      let typeList = this.ruleList.map(item => item.question_type)
      if(!typeList.includes(row.question_type))

      // 单选题-5、多选题-5、是非题-5、填空题-5、问答题-10;
      switch (row.question_type) {
        case 2001:
        case 2002:
        case 2003:
          scoreTemp = 5
          break;
        case 2004:
        case 2005:
          scoreTemp = 5
          break;
        case 2006:
          scoreTemp = 5
          break;
        case 2007:
          scoreTemp = 5
          break;
        case 2008:
          scoreTemp = 10
      }
      let isExist = this.ruleList.some(item => item.question_type == row.question_type)
      if(!isExist){
        this.ruleList.push({
          exam: this.$route.query.id,
          type_name : this.typeMap[ Number(row.question_type)] || '未知题型' ,
          question_type: row.question_type,
          question_scores: scoreTemp,
        })
      }

    },
    handleSort(){ //排序,按照单选,多选,填空,问答,判断
      const ORDER = [2001, 2002, 2003, 2004, 2005];
      this.displayAll.sort((a, b) => {
        const indexA = ORDER.indexOf(a.id);
        const indexB = ORDER.indexOf(b.id);
        // 如果某个 id 不在 ORDER 中（虽然你说了不会），放到最后
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
    },
    handleTabChange(){
      this.tableData2 = this.displayAll.filter(item => item.title == this.tabPosition)[0].dataList
    },
    // 删除操作,删除已选题目
    handleDelete(index, row) {
      // 备选题目列表中对应题目改为未选中状态
      const found = this.tableData.find(item => item.question_id === row.question_id)
      if (found) {
        found.isSelected = false;
      }
      //删除当前展示tab下的数据
      this.tableData2.splice(index, 1);
      if(this.tableData2.length == 0){
        //如果当前类型的题目被删空 和对应题目类型的分值/题量设置
        this.ruleList = this.ruleList.filter(item => item.question_type !== row.question_type)
        // 那么删除对应题目类型的tab
        this.displayAll = this.displayAll.filter(item => item.id !== row.question_type)
        this.tabPosition = this.displayAll[0].title
        this.handleTabChange()
      }
      // 删除的目标题目
      const targetQuestionType = row.question_type
      const targetQuestionId = row.question_id
      //删除接口获取的原始结构的数据，用以提交
      if (this.allQuestions[targetQuestionType]) {
        this.allQuestions[targetQuestionType] = this.allQuestions[targetQuestionType].filter(question =>
            !(question.question_type === targetQuestionType && question.question_id === targetQuestionId)
        );
      }
      // 删除展示结构的所有的数据，用以预览试卷
      this.displayAll.forEach(group => {
        group.dataList = group.dataList.filter(
            item => !(item.question_type === targetQuestionType && item.question_id === targetQuestionId)
        );
      });
    },
    handlePublish() { //发布
      // 遍历每个题型分组
      for (const [type, list] of Object.entries(this.allQuestions)) {
        list.forEach((item, index) => {
          // 从 1 开始（更符合“排序序号”语义）
          // item.sort_order = index + 1;

          // 如果你确实要从 0 开始，用下面这行代替：
          item.sort_order = index;
        });
      }
      let paramas = {
        exam_id: this.$route.query.id,
        questions: this.allQuestions,
        is_publish: true
      }
      saveExamQuestions(paramas).then(res => {// 更新保存考试选中题目
        if(res.code==200){
          this.$message.success('发布成功！')
          this.$router.push({path:'/cloudTraining/exam/examList'})
        }
      })

    },
    checkQuestionCount(displayAll, ruleList) { //校验设置题目数是否小于已选对应的类型的题数
      for (const rule of ruleList) {
        const item = displayAll.find(d => d.id === rule.question_type);
        if (!item) {
          this.$message.error(`未知题型: ${rule.question_type}`)
          return false;
        }

        if (rule.question_count > item.dataList.length) {
          const msg = `“${item.title}”题目不足！需 ${rule.question_count} 题，仅 ${item.dataList.length} 题可用`;
          this.$message.error(msg);
          return false;
        }
      }
      return true;
    },
    validateRuleList(ruleList) { //校验题量设置、规则设置中题目和分数是否填写完整
      for (const rule of ruleList) {
        // 校验 question_count：必须是 > 0 的数字
        if (
            rule.question_count === null ||
            rule.question_count === undefined ||
            rule.question_count === '' ||
            isNaN(Number(rule.question_count)) ||
            Number(rule.question_count) <= 0
        ) {
          this.$message.error('题目数量不能为空');
          return false;
        }

        // 校验 question_scores：不能为空（包括空字符串、null、undefined）
        if (
            rule.question_scores === null ||
            rule.question_scores === undefined ||
            rule.question_scores === '' ||
            String(rule.question_scores).trim() === ''
        ) {
          this.$message.error('题目分值不能为空');
          return false;
        }

        // 可选：校验分值是否为有效数字
        const score = parseFloat(rule.question_scores);
        if (isNaN(score) || score <= 0) {
          this.$message.error('题目分值必须为大于0的数字');
          return false;
        }
      }

      return true; // 校验通过
    },

    handleSave(type) { //保存
      this.isPublish = type
      if (!this.validateRuleList(this.ruleList)) { //校验规则设置必填
        return;
      }
      // 使用
      if (!this.checkQuestionCount(this.displayAll, this.ruleList)) { //校验题量设置和已选题目数量的匹配
        return; // 校验不通过直接终止
      }
      if(this.isNewRule){
        saveExamRule({exam_id: this.$route.query.id,rules_data:this.ruleList, is_verify:1}).then(res => {
          if(res.code==200){
            if(res.data){
              this.handleSaveQuestion()
            }else{
              this.validateDialog = true
            }
          }else{
           this.$message.error(res.msg)
          }
        })
      }else{
        updateExamRule({exam_id: this.$route.query.id,rules_data:this.ruleList,is_verify:1}).then(res => {
          if(res.code==200){
            if(res.data){
              console.log('cshijinrutijiaowenti')
              this.handleSaveQuestion()
            }else{
              this.validateDialog = true
            }
          }else{
            this.$message.error(res.msg)
          }
        })
      }
  // 修改结束
  //     let success1 = false
  //     let success2 = false
      // setTimeout(()=>{
      //   if(success1 && success2){
      //     this.$message.success('保存成功！')
      //     this.$router.push({path:'/cloudTraining/exam/examList'})
      //   }
      // },2000)
    },
    confirmSubmit() { //强制提交
      if(this.isNewRule){
        saveExamRule({exam_id: this.$route.query.id,rules_data:this.ruleList, is_verify:0}).then(res => {
          this.handleSaveQuestion()
        })
      }else{
        updateExamRule({exam_id: this.$route.query.id,rules_data:this.ruleList, is_verify:0}).then(res => {
          this.handleSaveQuestion()
        })
      }

    },
    handleSaveQuestion(){
      // 遍历每个题型分组
      console.log('this.allQuestions',this.allQuestions)
      for (const [type, list] of Object.entries(this.allQuestions)) {
        console.log('list',list)
        list.forEach((item, index) => {
          item.sort_order = index;
        });
      }
      let paramas = {
        exam_id: this.$route.query.id,
        questions: this.allQuestions,
        is_publish: this.isPublish == 1 ? true : false
      }
      saveExamQuestions(paramas).then(res => {// 更新保存考试选中题目
        if(res.code==200){
          this.$message.success(this.isPublish == 1 ? '发布成功！' : '保存成功！')
          this.$router.push({path:'/cloudTraining/exam/examList'})
        }
      })
    },
    handlePreview() { //预览
      sessionStorage.setItem('selectedList', []);
      sessionStorage.setItem('ruleList', []);
      sessionStorage.setItem('isNewRule', '');
      sessionStorage.setItem('allQuestions', []);
      sessionStorage.setItem('selectedList', JSON.stringify(this.displayAll));
      sessionStorage.setItem('allQuestions', JSON.stringify(this.allQuestions));
      sessionStorage.setItem('ruleList', JSON.stringify(this.ruleList));
      sessionStorage.setItem('isNewRule', JSON.stringify(this.isNewRule));
      setTimeout(()=>{
        this.$router.push({path:'/cloudTraining/exam/previewExam',query:{id:this.$route.query.id}})
      },500)
    },
    handleCancel() { //取消
      sessionStorage.removeItem('selectedList', []);
      sessionStorage.removeItem('ruleList', []);
      sessionStorage.removeItem('allQuestions', []);
      sessionStorage.removeItem('isNewRule', null);
      this.$router.push({path:'/cloudTraining/exam/examList',})
    },
  },
  beforeDestroy() {
    // 清理定时器、取消订阅等
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form-item{
  display: inline-block;
}
.half{
  width: 50%;
}
::v-deep .half .el-input{
  width: 90%;
  margin-right: 8px;
}
::v-deep .el-input .el-input__inner{
  width: 100%;
}
.socre-item{
  display: inline-block;
  width: 18%;
  padding:0 8px;
  border: 1px solid #eee;
  border-right: none;
  position: relative;
  .label {
    display: inline-block;
    text-align: right;
  }

}
.socre-item:last-child{
  border-right: 1px solid #eee;
}
.label {
  position: absolute;
  vertical-align: middle;
  font-weight: bold;
  color: #333;
  top:calc(50% - 20px);
}

.value {
  padding-left: 26%;
  display: inline-block;
  vertical-align: middle;
  text-align: right;
}
</style>